import React from 'react';
import Slider from 'react-slick';
import { redirectToProductDetails } from '../../../utils';
import NoImage from '../../../assets/images/no-image.png';

function ProductItems({
  itemsTopSelling,
  storefront,
  brandsTopSelling,
  preferredProducts,
  preferredBrands,
}) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const imagesData =
    itemsTopSelling || brandsTopSelling || preferredProducts || preferredBrands;

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {imagesData?.slice(0, 6).map((product, index) => (
          <div
            key={index}
            className="p-4 relative cursor-pointer"
            onClick={() =>
              redirectToProductDetails(
                storefront?.general?.shopUrl +
                  `${
                    product?.__typename === 'Brand' ? '/brands/' : '/products/'
                  }` +
                  product?.slug
              )
            }
          >
            <img
              src={
                product?.primaryImage?.mediumUrl ||
                product?.primaryImage?.thumbUrl ||
                product?.coverImage?.mediumUrl ||
                product?.coverImage?.thumbUrl ||
                NoImage
              }
              alt={`Product ${index + 1}`}
              className="w-full"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ProductItems;
